import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';
import { CommonStaffApiServiceService } from '../../common-staff-api-service.service';
import { ToasterService } from '../../../../providers/toaster/toaster.service';
import { LoaderComponent } from "../../../../providers/loader.component";
import { StaffStudentCommonProfileViewComponent } from "../../../../components/personnel-component/staff-student-common-profile-view/staff-student-common-profile-view.component";
import { ClassroomSyllabusCardComponent } from "../../../../components/dashboard-components/classroom-syllabus-card/classroom-syllabus-card.component";

@Component({
  selector: 'app-teacher-details',
  standalone: true,
  imports: [CommonModule, LoaderComponent, StaffStudentCommonProfileViewComponent, ClassroomSyllabusCardComponent],
  templateUrl: './teacher-details.component.html',
  styleUrl: './teacher-details.component.css'
})
export class TeacherDetailsComponent {
  teacherId: number | string | null = null;
  teacherData: any = null;
  isFetching: boolean = false;

  activeTab: 'analytics' | 'courses' | 'classes' | 'activity' = 'analytics';

  recentViewed = [
    { title: 'Port Combined Video', class: '6th (A)', img: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=640&auto=format&fit=crop' },
    { title: 'Port Combined Video', class: '6th (A)', img: 'https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?q=80&w=640&auto=format&fit=crop' }
  ];

  upcomingSessions = [
    { date: '20th Dec, 2024', time: '11:00 am', title: 'English Vocab - Video 500', badge: '6th (A)' },
    { date: '20th Dec, 2024', time: '11:00 am', title: 'English Vocab - Video 500', badge: '7th (B)' },
    { date: '20th Dec, 2024', time: '11:00 am', title: 'English Vocab - Video 500', badge: '5th (A)' },
    { date: '20th Dec, 2024', time: '11:00 am', title: 'English Vocab - Video 500', badge: '9th (A)' }
  ];

  courses = [
    { name: 'English Vocab - 500', classes: '5A, 5C' },
    { name: 'English Vocab - 500', classes: '6A, 6B, 6C' },
    { name: 'English Vocab - 500', classes: '6A, 6B, 6C' },
    { name: 'English Vocab - 500', classes: '6A, 6B, 6C' }
  ];

  classBatches = [
    {
      className: 'Class 5',
      batches: ['Batch A', 'Batch B', 'Batch C'],
      progress: 45,
      thumbnails: [
        'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=240&auto=format&fit=crop',
        'https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?q=80&w=240&auto=format&fit=crop',
        'https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=240&auto=format&fit=crop',
        'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=240&auto=format&fit=crop',
        'https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?q=80&w=240&auto=format&fit=crop',
        'https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=240&auto=format&fit=crop'
      ]
    },
    { className: 'Class 6', batches: [], progress: 0, thumbnails: [] },
    { className: 'Class 7', batches: [], progress: 0, thumbnails: [] }
  ];

  activityLog = [
    { date: '28-Dec-24', time: '03:16 pm', text: 'New Student Created', status: 'success' },
    { date: '27-Dec-24', time: '03:16 pm', text: 'Password Changed', status: 'success' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Video Streamed for Class 7C - completed on 04:20 pm', status: 'success' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Deleted Student - Prajakta Bhavsar BA', status: 'error' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Added Remark for \"Complete video of Port\" for class 5A', status: 'success' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Made Test live for Students', status: 'success' },
    { date: '25-Dec-24', time: '03:16 pm', text: 'Made Test live for Students', status: 'success' }
  ];

  constructor(
    private route: ActivatedRoute,
    private staffApiService: CommonStaffApiServiceService,
    private toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.teacherId = id;
      if (!id) {
        this.teacherData = null;
        return;
      }
      this.fetchTeacherDetails(id);
    });
  }

  fetchTeacherDetails(id: number | string) {
    this.isFetching = true;
    this.staffApiService.getStaffProfile(id)
      .pipe(finalize(() => { this.isFetching = false; }))
      .subscribe({
        next: (res: any) => {
          if (res?.status === 'success') {
            this.teacherData = res?.data ?? null;
          } else {
            this.teacherData = null;
            this.toasterService.setToaster('error', 'Error', res?.message ?? 'Failed to fetch teacher details');
          }
        },
        error: (err) => {
          console.error('HTTP error:', err);
          this.teacherData = null;
          this.toasterService.setToaster('error', 'Error', 'Failed to fetch teacher details');
        }
      });
  }
}
